import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export default function TrusteeDigestSettingsCard() {
  const [prof, setProf] = useState(null);
  const [s, setS] = useState({ digest_opt_out: false, digest_hour: 7 });
  useEffect(() => {
    apiClient.get("/my/trustee/profile").then((r) => setProf(r.data)).catch(() => {});
    apiClient.get("/my/trustee/digest-settings").then((r) => setS(r.data)).catch(() => {});
  }, []);
  if (!prof || prof.mandates === 0) return null;
  const save = async () => {
    try { const r = await apiClient.put("/my/trustee/digest-settings", s); setS(r.data); toast.success("Tagesmail-Einstellungen gespeichert"); }
    catch (e) { toast.error(e.response?.data?.detail || "Fehler"); }
  };
  return (
    <Card className="p-5 border border-slate-200 mt-4" data-testid="trustee-digest-settings-card">
      <div className="flex items-center gap-2 mb-2"><Mail className="h-4 w-4 text-slate-600" /><h3 className="text-sm font-semibold text-slate-900">Treuhänder-Tagesmail</h3></div>
      <p className="text-xs text-slate-500 mb-3">Morgendliche Übersicht aller offenen Prüfungen über Ihre {prof.mandates} Mandanten (nur wenn etwas offen ist).</p>
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <label className="flex items-center gap-2"><input type="checkbox" checked={!s.digest_opt_out} onChange={(e) => setS({ ...s, digest_opt_out: !e.target.checked })} data-testid="digest-enabled" /> Tagesmail erhalten</label>
        <label className="flex items-center gap-2">Uhrzeit
          <select className="h-8 rounded-md border border-slate-200 px-2 text-sm" value={s.digest_hour} disabled={s.digest_opt_out} onChange={(e) => setS({ ...s, digest_hour: Number(e.target.value) })} data-testid="digest-hour">
            {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{String(h).padStart(2, "0")}:30</option>)}
          </select>
        </label>
        <Button size="sm" onClick={save} className="rounded-full" data-testid="digest-save">Speichern</Button>
      </div>
    </Card>
  );
}
